import React, { useEffect, useState } from "react";
import { BackTop, Button, Col, Row } from "antd";
import { UniqueId } from "@/utils/string";
import { PlayCircleOutlined } from "@ant-design/icons/lib";
import { useDispatch } from "react-redux";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel } from "@/features/backtest";
import { useFirestoreConnect } from "react-redux-firebase";
import moment from "moment";

import Options from "./Options";
import Strategy from "./Strategy";
import Progress from "./Progress";
import Models from "./Models"
import styles from "./styles.less";
import btnStyles from "../styles.less";
import { useSetupContext } from "../hooks";

export default () => {
  useFirestoreConnect([{ collection: "backtest_snapshot" }]);
  const dispatch = useDispatch();
  const { setPage } = useSetupContext();
  const [isRun, setIsRun] = useState(false);
  const [taskId, setTaskId] = useState(UniqueId);
  const setup = useRootSelector(BacktestSel.setup);
  const isBacktestLoading = useRootSelector(BacktestSel.isBacktestLoading);
  const isBacktestError = useRootSelector(BacktestSel.isBacktestError);
  const isBacktestSuccess = useRootSelector(BacktestSel.isBacktestSuccess);

  useEffect(() => {
    // Track if backtesting run success and go to result automatically
    isBacktestLoading && setIsRun(true);

    if (isRun && isBacktestSuccess) {
      setIsRun(false);
      setPage("results");
    }
  }, [isBacktestLoading]);

  useEffect(() => {
    isBacktestError && setTaskId(UniqueId());
  }, [isBacktestError]);

  return (
    <Row justify={"space-between"} className={styles.content} gutter={[16, 8]}>
      <Col span={8}>
        <Options />
      </Col>
      <Col span={16}>
        <Row justify={"end"} style={{ marginTop: -50, marginBottom: 20 }}>
          <Button
            loading={isBacktestLoading}
            icon={<PlayCircleOutlined />}
            onClick={() => dispatch(BacktestAction.fetchBacktestResult.request({ setup, taskId }))}
            className={[btnStyles.radioRightButton, btnStyles.radioLeftButton].join(" ")}
          >
            Run Backtest
          </Button>
        </Row>
        {(isBacktestLoading || isBacktestError) && (
          <Progress taskId={taskId} datetime={moment().format("MMMM Do YYYY h:mm a")} />
        )}
        <Strategy />
        {/*<Models/>*/}
      </Col>
      <BackTop />
    </Row>
  );
};
